export const PRODUCT = 'PRODUCT';
export const BUNDLE = 'BUNDLE';
export const COURSE = 'COURSE';
export const COURSE_AND_PRODUCT = 'COURSE_PRODUCT';
export const PRODUCT_BUNDLE = 'PRODUCT_BUNDLE';

